module.exports = __webpack_public_path__ + "img/cartao-de-credito.5b2870b5.png";